import { render, staticRenderFns } from "./AllEatInfoBox.vue?vue&type=template&id=371b08fe&scoped=true&"
import script from "./AllEatInfoBox.vue?vue&type=script&lang=js&"
export * from "./AllEatInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./AllEatInfoBox.vue?vue&type=style&index=0&id=371b08fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b08fe",
  null
  
)

export default component.exports